import { Checkbox } from "@mui/material";
import { ICellRendererParams } from "ag-grid-community";
import React from "react";

export type CheckboxRendererProps<TData = any> = {
    disabled?: boolean;
    onChange?: (data: TData, checked: boolean) => void;
} & ICellRendererParams;

export default function CheckboxRenderer<TData = any>({ value,
    node,
    column,
    disabled,
    onChange
}: CheckboxRendererProps<TData>) {

    function onChecked(_event: React.ChangeEvent<HTMLInputElement>, checked: boolean) {
        if (onChange) {
            if (node.rowIndex !== undefined && node.rowIndex !== null) {
                onChange(node.data, checked);
            }
        } else {
            let colId = column?.getColId();
            if (colId) {
                node.setDataValue(colId, checked);
            }
        }
    }

    return (
        <Checkbox
            disabled={disabled}
            size="small"
            checked={value}
            onChange={onChecked}
            sx={{
                padding: 0
            }}
        />
    )
}
